import styled from 'styled-components';
import etiqueta from '../../img/etiqueta.svg';

const FormCarrinho = styled.div`
	.checkout-items h3 {
		margin: 0 0 15px 0;
		color: ${({ theme }) => theme.colorCheckoutItemsH3FormCarrinho};
		text-align: center;
		font-family: ${({ theme }) => theme.fontFamilyCheckoutItemsH3FormCarrinho};
	}

	.plans h2 {
		font-family: ${({ theme }) => theme.fontFamilyPlansH2FormCarrinho};
		font-size: 20px;
	}

	.gray .row {
		margin: 0 0 0 0px !important;
	}

	.installments {
		margin: 2rem -2rem;

		@media (min-width: 768px) {
			margin: 2rem 0;
		}
	}

	.installment {
		display: flex;
		flex-direction: column;
		justify-content: space-evenly;
		text-align: center;
		border-radius: 10px;
		width: 80vw;
		max-width: 320px;
		height: 200px;
		margin: 0 1rem;
		box-shadow: 0 5px 10px
			${({ theme }) => theme.boxShadowInstallmentFormCarrinho};
		position: relative;
		transition: all 0.3s;
		background-color: ${({ theme }) => theme.backgroundInstallmentFormCarrinho};

		@media (min-width: 500px) {
			width: 80vw;
		}

		@media (min-width: 700px) and (max-width: 800px) {
			max-width: 220px;
			margin: 0 0.5rem;
		}
	}

	.installment.active,
	.installment.active:hover {
		-webkit-box-shadow: 0px 0px 0px 5px
			${({ theme }) => theme.boxShadowInstallmentHoverFormCarrinho};
		-moz-box-shadow: 0px 0px 0px 5px
			${({ theme }) => theme.boxShadowInstallmentHoverFormCarrinho};
		box-shadow: 0px 0px 0px 5px
			${({ theme }) => theme.boxShadowInstallmentHoverFormCarrinho};
	}

	.installment:hover {
		-webkit-box-shadow: 0px 0px 0px 2px
			${({ theme }) => theme.boxShadowInstallmentHoverFormCarrinho};
		-moz-box-shadow: 0px 0px 0px 2px
			${({ theme }) => theme.boxShadowInstallmentHoverFormCarrinho};
		box-shadow: 0px 0px 0px 2px
			${({ theme }) => theme.boxShadowInstallmentHoverFormCarrinho};
	}

	.installment h2 {
		margin: 0;
		color: ${({ theme }) => theme.colorInstallmentH2FormCarrinho};
	}

	.installment .title {
		font-size: 2.2rem;
	}

	.installment h2.avoid-tag {
		margin: 0 2rem 0 1rem;
		text-align: left;
	}

	.installment .tag {
		position: absolute;
		top: -1.5rem;
		right: 10px;
		background-image: url(${etiqueta});
		background-size: 100% 100%;
		width: 49px;
		height: 60px;
		color: ${({ theme }) => theme.colorInstallmentTagPercentageFormCarrinho};
		text-align: center;
		padding: 0.8em 0;
		box-sizing: border-box;
		font-family: ${({ theme }) =>
			theme.fontFamilyInstallmentTagPercentageFormCarrinho};
	}

	.installment .text-installment {
		color: ${({ theme }) => theme.colorTextInstallmentFormCarrinho};
		font-size: 1.7rem;

		.installment-price {
			color: ${({ theme }) => theme.colorInstallmentPriceFormCarrinho};
			font-size: 2rem;
			position: relative;
			left: 2rem;
		}

		span {
			position: relative;
			display: block;
			top: 3rem;
			left: -7rem;
			font-size: 0.8em;
		}

		strong {
			font-size: 2.5em;
		}
	}

	.installment .text-total {
		font-size: 0.9em;
		color: ${({ theme }) => theme.colorInstallmentTextTotalFormCarrinho};
		font-family: ${({ theme }) =>
			theme.fontFamilyInstallmentTextTotalFormCarrinho};
	}

	.installment label {
		cursor: pointer;
		padding: 2rem;
		display: flex;
		flex-direction: column;
		justify-content: space-evenly;
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
	}

	.box {
		height: 20px;
		border-bottom-left-radius: 10px;
		border-bottom-right-radius: 10px;
		position: absolute;
		bottom: 0;
		width: 100%;
	}

	.installments:nth-of-type(n) .box {
		background-color: ${({ theme }) =>
			theme.backgroundInstallmentsFirstBoxFormCarrinho};
	}
	.installments:nth-of-type(2n) .box {
		background-color: ${({ theme }) =>
			theme.backgroundInstallmentsSecondBoxFormCarrinho};
	}
	.installments:nth-of-type(3n) .box {
		background-color: ${({ theme }) =>
			theme.backgroundInstallmentsThirdBoxFormCarrinho};
	}

	.installment input {
		display: none;
	}

	.text-information-plan {
		hr {
			border: none;
			height: 1px;
			width: 100%;
			background: ${({ theme }) =>
				theme.backgroundTextInformationPlanHrFormCarrinho};
			margin: 1em 0 1.5em;
		}

		.title {
			text-align: center;
			font-size: 1.1em;
			margin-top: -1em;
			color: ${({ theme }) => theme.colorTextInformationPlanTitleFormCarrinho};
			font-family: ${({ theme }) =>
				theme.fontFamilyTextInformationPlanTitleFormCarrinho};
		}

		.info-block {
			display: flex;
			justify-content: space-between;
			margin: auto 26px;

			h3 {
				color: ${({ theme }) => theme.colorInfoBlockH3FormCarrinho};
				font-family: ${({ theme }) => theme.fontFamilyInfoBlockH3FormCarrinho};
				font-weight: bold;
				font-size: 1.2em;
			}

			div {
				font-size: 1.5rem;
				text-align: right;

				p {
					color: ${({ theme }) => theme.colorInfoBlockParagraphFormCarrinho};
					margin: 0 0 0.3em;
					line-height: 1;
					font-family: ${({ theme }) =>
						theme.fontFamilyInfoBlockParagraphFormCarrinho};
				}

				.details {
					font-family: ${({ theme }) =>
						theme.fontFamilyInfoBlockDetailsFormCarrinho};
					color: ${({ theme }) => theme.colorInfoBlockDetailsFormCarrinho};
					font-size: 0.65em;
					margin-left: 2em;
				}
			}
		}
	}

	.graceText {
		width: 100%;
		text-align: center;
		font-size: 13px;
		color: ${({ theme }) => theme.colorGraceTextFormCarrinho};
		vertical-align: middle;
		font-family: ${({ theme }) => theme.fontFamilyGraceTextFormCarrinho};
	}

	.container-checkbox {
		display: block;
		position: relative;
		margin: 10px 0 0 0;
		cursor: pointer;
		font-size: 22px;
		-webkit-user-select: none;
		-moz-user-select: none;
		-ms-user-select: none;
		user-select: none;
	}

	/* Hide the browser's default checkbox */
	.container-checkbox input {
		position: absolute;
		opacity: 0;
		cursor: pointer;
		height: 0;
		width: 0;
	}

	/* Create a custom checkbox */
	.checkmark {
		position: absolute;
		top: 0;
		left: 0;
		height: 25px;
		width: 25px;
		background-color: ${({ theme }) => theme.backgroundCheckmarkFormCarrinho};
		border: 1px solid ${({ theme }) => theme.borderCheckmarkFormCarrinho};
	}

	/* On mouse-over, add a grey background color */
	.container-checkbox:hover input ~ .checkmark {
		background-color: ${({ theme }) =>
			theme.backgroundContainerCheckboxHoverFormCarrinho};
	}

	/* Create the checkmark/indicator (hidden when not checked) */
	.checkmark:after {
		content: '';
		position: absolute;
		display: none;
	}

	/* Show the checkmark when checked */
	.container-checkbox input:checked ~ .checkmark:after {
		display: block;
	}

	/* Style the checkmark/indicator */
	.checkmark:after {
		left: 8px;
		top: 5px;
		width: 8px;
		height: 14px;
		border: solid ${({ theme }) => theme.borderCheckmarkAfterFormCarrinho};
		border-width: 0 3px 3px 0;
		-webkit-transform: rotate(45deg);
		-ms-transform: rotate(45deg);
		transform: rotate(45deg);
	}

	.benefits-add2 {
		width: 100%;
		padding: 0 0 0 35px;
		text-align: left;
		font-size: 16px;
		color: ${({ theme }) => theme.colorBenefitsAdd2FormCarrinho};
		vertical-align: middle;
		font-family: ${({ theme }) => theme.fontFamilyBenefitsAdd2FormCarrinho};
		cursor: pointer;
	}

	@media (min-width: 729px) and (max-width: 1360px) {
		.checkout-items h3 {
			font-size: 17px;
		}

		.plans h2 {
			font-size: 20px;
		}
	}

	@media (max-width: 728px) {
		.container-checkbox {
			margin-top: 30px;
		}

		.benefits-add2 strong {
			font-size: 15px;
			display: block;
		}
	}

	@media (max-width: 512px) {
		.plans {
			h2 {
				font-size: 20px;
			}
		}

		.container-checkbox {
			margin-top: 30px;
		}

		.benefits-add2 strong {
			font-family: ${({ theme }) => theme.fontFamilyBenefitsAdd2FormCarrinho};
			font-size: 15px;
			display: block;
			margin-bottom: 25px;
			color: ${({ theme }) => theme.colorBenefitsAdd2FormCarrinho};
		}
	}

	@media screen and (min-width: 320px) {
		.benefits-add2 strong {
			font-size: 15px;
			display: block;
			color: ${({ theme }) => theme.colorBenefitsAdd2FormCarrinho};
		}
	}
`;

export default FormCarrinho;
